import { useEffect, useState } from '@wordpress/element';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Loading } from './Loading';
import './style.scss';
import parse from 'html-react-parser';

const localToken = localStorage.getItem('TokenCampusPiemonte')

const clientId = '9b7fa12a-0a56-4f8e-a018-c6335d8f0d14'; // USER
const clientSecret = 'm2OcL7md1SSEs2wkV94UG0H29ewTcYxt0SHSz3tZ'; // USER
const tokenUrl = 'https://api.campuspiemonte.com/public/oauth/token';
const baseURL = 'https://api.campuspiemonte.com/public/';
const password = 'edisu2024!' // USER
const username = 'test@edisu' // USER


export function APIBlock({urlSelected, languageSelected }) {
  const [data, setData] = useState();
  const [openAccordions, setOpenAccordions] = useState({});
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState('');

  const toggleAccordion = (id) => {
    setOpenAccordions(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  async function getAccessToken(username, password, clientId, clientSecret, tokenUrl) {
    const params = new URLSearchParams();
    params.append('grant_type', 'password');
    params.append('username', username);
    params.append('password', password);
    // params.append('grant_type', 'client_credentials');
    params.append('client_id', clientId);
    params.append('client_secret', clientSecret);


  
    const response = await fetch(tokenUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params
    })
    const data = await response.json();
    console.log(data)
    return data;
    
  }
  
  async function makeRestCall(baseURL, urlSelected, accessToken, languageSelected) {
    // TODO INSERIRE LANGUAGE nella posizione corretta perché può essere che non funziona
    const resp = await fetch(`${baseURL}api/v1/getdata?table=${urlSelected}${languageSelected}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`
      }
    })
    .then((resp) => resp.json())
    .then((response) => {
        // Filtra i dati con deleted_at == null
        const filteredData = response.filter(item => item.deleted_at === null);
        setData(filteredData);
        const uniqueCities = [...new Set(response.map(item => item.comune))]
      setCities(uniqueCities);
      console.log(urlSelected);
      console.log(response);
    })
    .catch((error) => console.log("Errore nella richiesta", error)); 
    
    
    
  }

  useEffect(() => {

    try {
      if (localToken) {
        console.log('il token è presente');
        makeRestCall(baseURL, urlSelected, localToken, languageSelected)
      } else {
        console.log('non leggo il token - sto facendo la chiamata');
        getAccessToken(username, password, clientId, clientSecret, tokenUrl).then((res)=>{
          makeRestCall(baseURL, urlSelected, res.access_token, languageSelected)
          console.log('token Api: ' + res.access_token)
          localStorage.setItem("TokenCampusPiemonte", res.access_token)
        })
      }
    } catch (error) {
      console.error('Errore:', error);
    }

  }, [urlSelected,languageSelected]);

  // TODO Per richiamare un'eventuale ancora
  // const getAnchorFromUrl = () => {
  //   const hash = window.location.hash;
  //   return hash ? hash.substring(1) : null;
  // };

  const filteredData = selectedCity
    ? data?.filter(item => item.comune == selectedCity)
    : data;

  	

  return (
  <>
    
    <div id='APIBridgeConnect'>
      
      <div className="filter-buttons">
        <button
          className={`filter-button ${selectedCity === '' ? 'active' : ''}`}
          onClick={() => setSelectedCity('')}
        >
          Tutte le città
        </button>

        {cities.map(city => (
          <button
            key={city}
            className={`filter-button ${selectedCity == city ? 'active' : ''}`}
            onClick={() => setSelectedCity(city)}
            href={`#${city}`}
          >
            {city}
          </button>
        ))}
      </div>

      {filteredData ? (
        filteredData.map((item) => {
          const isOpen = openAccordions[item.id] || false;
          
          return (
            
            <div key={item.id} className='accordion'> 
              <h2 className='accordion-button' onClick={() => {toggleAccordion(item.id)} } name={item.alt}>
                {item.nome} 
                {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}		
              </h2>

              {isOpen && (
                <>
                  <div className='item_info'>
                    {item.struttura && <p>{item.struttura}</p>}
                    {item.indirizzo &&<p><strong>Indirizzo:</strong> <br/>{parse(`${item.indirizzo}`)}</p>}
                    {item.telefono && <p><strong>Telefono:</strong> {item.telefono}</p>}
                    {item.email && <p><strong>Email:</strong> {item.email}</p>}
                    {item.orari && <p><strong>Orari:</strong> <br/>{parse(`${item.orari}`)}</p>}
                    {item.info && <p><strong>Attività sportive e ricreative:</strong> {item.info}</p>}
                  </div>
                  <div className='table'>
                    {(item.come_raggiungerla || item.url_maps) && (
                      <div className='table_location subtable'>
                        <h3>Come arrivarci</h3>
                        {item.come_raggiungerla && <p>{parse(`${item.come_raggiungerla}`)}</p>}
                        {item.url_maps && <a href={item.url_maps} target='_blank' rel="noopener noreferrer">Visualizza sulla mappa</a>}
                      </div>
                    )}
                    {(item.capienza || item.come_accedere || item.gestione || item.destinatari || item.notizie || item.condizioni_servizio || item.allegati || item.link_prestito_testi) && (
                      <div className='table_info subtable'>
                        <h3>Informazioni utili</h3>
                        {item.capienza && <p><strong>Capienza:</strong> {item.capienza}</p>}
                        {item.come_accedere && <p><strong>Come accedere:</strong> {parse(`${item.come_accedere}`)}</p>}
                        {item.gestione && <p><strong>Gestione:</strong> {item.gestione}</p>}
                        {item.destinatari && <p><strong>Destinatari:</strong> {item.destinatari}</p>}
                        {item.notizie && <p><strong>Notizie:</strong> {item.notizie}</p>}
                        {item.condizioni_servizio && <p><strong>Condizioni di servizio: </strong> {item.condizioni_servizio}</p>}
                        {item.allegati && <a href={item.allegati} target='_blank' rel="noopener noreferrer">Guarda l'allegato</a>}
                        {item.link_prestito_testi && <a href={item.link_prestito_testi} target='_blank' rel="noopener noreferrer">Prestito testi</a>}    
                      </div>
                    )}
                    {(item.link_come_accedere) && (
                      <div className='table_access_botton subtable'>
                        <h3>Come accedere</h3>
                        <h4>Prenotazione tramite Campus Piemonte ID Studyroom</h4>
                        <p>{item.come_accedere}</p>
                        <a href={item.link_come_accedere} target='_blank' rel="noopener noreferrer">{item.bottone_come_accedere}</a> 
                        </div>
                    )}
                    {(item.camere || item.camere_dotazioni) && (
                      <div className='table_info subtable'>
                        <h3>Informazioni sulle camere</h3>
                        
                        {item.camere && <p><strong>Camera:</strong> <br/> {parse(`${item.camere}`)}</p>}
                        {item.camere_dotazioni && <p><strong>Dotazioni camere:</strong> <br/>{parse(`${item.camere_dotazioni}`)}</p>}
                      </div>
                    )}
                    {(item.servizi || item.servizi_correlati || item.link_oggetti_smarriti) && (
                    <div className='table_menu subtable'>
                      <h3>Servizi</h3>
                      {item.servizi && <p>{parse(`${item.servizi}`)}</p>}
                      {item.servizi_correlati && <p><strong>Servizi Correlati:</strong> {parse(`${item.servizi_correlati}`)}</p>}
                      {item.link_oggetti_smarriti && <a href={item.link_oggetti_smarriti} target='_blank' rel="noopener noreferrer">Oggetti smarriti</a>}    
                      </div>)
                    }
                    {(item.menu || item.menu_cena) && (
                      <div className='table_menu subtable'>
                        <h3>Menù</h3>
                        <p>Visualizza il menù</p>
                        {item.menu && <a href={item.menu}>Menù</a>}
                        {item.menu_cena && <a href={item.menu_cena}>Menù Cena</a>}
                      </div>
                    )}
                    {(item.tariffe_url || item.tariffe) && (
                      <div className='table_meal subtable'>
                        <h3>Tariffe Pasti</h3>
                        {item.tariffe_url && <a href={item.tariffe_url} target='_blank' rel="noopener noreferrer">Consulta qui le formule e tariffe per i pasti</a>}
                        {item.tariffe && <p>{parse(`${item.tariffe}`)}</p>}
                        </div>
                    )}
                    {item.tariffe_eventi &&
                      <div className='table_events subtable'>
                        <h3>Tariffe Eventi</h3>
                        <p>{parse(`${item.tariffe_eventi}`)}</p>
                      </div>
                    }
                  </div>
                </>
              )}
            </div>
          );
        })
      ) : (
        <Loading />
      )}
    </div>
  </>
  );
}